/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
  var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();

function animateCountUp(element, endValue, duration = 1500) {
  let startTime;
  const startValue = 0;
  const isDecimal = endValue % 1 !== 0;

  console.log(endValue);

  function updateNumber(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    // const currentValue = Math.floor(
    //   progress * (endValue - startValue) + startValue
    // ).toLocaleString();
    const currentValue = progress * (endValue - startValue) + startValue;
    element.textContent = isDecimal
      ? currentValue.toFixed(1)
      : Math.floor(currentValue).toLocaleString();

    if (progress < 1) {
      requestAnimationFrame(updateNumber);
    }
  }
  requestAnimationFrame(updateNumber);
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function onScroll() {
  document.querySelectorAll("[data-tally]").forEach((counter) => {
    if (isInViewport(counter) && !counter.classList.contains("visible")) {
      counter.classList.add("visible");
      animateCountUp(counter, parseFloat(counter.dataset.tallyValue, 10));
    }
  });
}

window.addEventListener("scroll", onScroll);
window.addEventListener("load", onScroll);

document.addEventListener("DOMContentLoaded", function () {
  const filters = document.getElementById("blogFilter");

  if (filters) {
    const filtersTxt = filters.innerHTML;

    filters.addEventListener("click", (e) => {
      document
        .querySelector(".blog__header--filter-bar")
        .classList.toggle("is-active");

      if (
        document
          .querySelector(".blog__header--filter-bar")
          .classList.contains("is-active")
      ) {
        filters.innerHTML = 'close filters <i class="icon-close"></i>';
      } else {
        filters.innerHTML = filtersTxt;
      }
    });
  }
});
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {});

// END jQuery Ready
function detectScrollbarWidth() {
  /* Detect scrollbar width to properly center full- and wide-width elements */
  let root = document.documentElement;
  var outside = document.createElement("div");
  var inside = document.createElement("div");

  outside.style.width = inside.style.width = "100%";
  outside.style.overflow = "scroll";
  document.body.appendChild(outside).appendChild(inside);

  var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

  outside.parentNode.removeChild(outside);
  root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
  var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6, p");

  headings.forEach(function (head, index) {
    let str = head.textContent;
    let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
    let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

    firstSection = firstSection.trim();

    let newStr = firstSection + "\u00a0" + lastSection;

    head.innerHTML = newStr;
  });
}
